import microApp from '@micro-zoe/micro-app'
import { PREFIX } from '../utils/constant'
import PluginLoader from './PluginLoader'
import StaticPluginLoader from './StaticPluginLoader'

export default function install (Vue, options = {}) {
  Vue.component(`${PREFIX}${PluginLoader.name}`, PluginLoader)
  Vue.component(`${PREFIX}${StaticPluginLoader.name}`, StaticPluginLoader)

  microApp.start({
    lifeCycles: {
      created (e) {
        console.log('[@ccprivate/plugin-engine-saas][plugin-loader] created', e.detail)
      },
      beforemount (e) {
        console.log('[@ccprivate/plugin-engine-saas][plugin-loader] beforemount', e.detail)
      },
      mounted (e) {
        console.log('[@ccprivate/plugin-engine-saas][plugin-loader] mounted', e.detail)
      },
      unmount (e) {
        console.log('[@ccprivate/plugin-engine-saas][plugin-loader] unmount', e.detail)
      },
      error (e) {
        console.log('[@ccprivate/plugin-engine-saas][plugin-loader] error', e.detail)
      }
    }
  })
}
